import { AutoMap } from "@automapper/classes";
import { UserDTO } from "../services/dto/user.dto";
import { mapper } from "../tools/mapping/mapper";


export class User {
    @AutoMap()
    Email!: string;
    @AutoMap()
    Phone!: string;
    @AutoMap()
    FirstName!: string;
    @AutoMap()
    LastName!: string;


    static mapFromJSON(json: any) {
        let u = new User();
        u = mapper.map(json, UserDTO, User);
        return u;
    }
}
